import { render } from "./ResetPasswordECPView.vue?vue&type=template&id=53009acc&ts=true"
import script from "./ResetPasswordECPView.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordECPView.vue?vue&type=script&lang=ts"

import "./ResetPasswordECPView.vue?vue&type=style&index=0&id=53009acc&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__